<template>
    <a href="#" :class="classes" @click.prevent="handleClick">
        <span :class="iconClass"></span>{{ followText }}
    </a>
</template>

<script>
const sharedState = [];

export default {
    props: {
        blogId: Number,
        url: String,
        followers: Number,
        following: Boolean,
        initIsFollowing: Boolean
    },

    mounted() {
        this.$set(this.state, this.blogId, this.following);

        // this.following = this.initIsFollowing;
    },

    data: function () {
        return {
            classes: { 'follow-user-button': true },

            state: sharedState,

            disableButton: false
        };
    },

    computed: {
        followText: function () {
            if (this.isFollowing) {
                return 'Följer';
            } else {
                return 'Följ';
            }
        },

        iconClass: function () {
            return {
                'icon-star': this.isFollowing,
                'icon-star-outlined': !this.isFollowing
            };
        },

        isFollowing: {
            get: function () {
                return this.state[this.blogId];
            },

            set: function (newValue) {
                this.$set(this.state, this.blogId, newValue);
            }
        }
    },

    methods: {
        handleClick: function () {
            if (this.disableButton) return;

            this.disableButton = true; // Disable button

            this.toggleFollow();

            request.post(this.url).end((err, res) => {
                if (err) {
                    this.toggleFollow();
                    console.error(err);
                }

                this.disableButton = false; // Enable button
            });
        },

        toggleFollow: function () {
            this.$set(this.state, this.blogId, !this.isFollowing);
        }
    }
};
</script>
